import { paddleConfiguratorUrl } from "./paddle";

export const configuratorLinkFromSuccessUrl = (search: string) => {
  const params = new URLSearchParams(search);
  const orderId = params.get("order_id");
  const checkoutToken = params.get("checkout_token");
  if (!orderId || !checkoutToken) return null;

  const configuratorUrl = new URL(paddleConfiguratorUrl);
  configuratorUrl.searchParams.set("order_id", orderId);
  configuratorUrl.searchParams.set("checkout_token", checkoutToken);
  const planId = params.get("plan");
  if (planId === "personal-coach" || planId === "club-company") {
    configuratorUrl.searchParams.set("plan", planId);
  }
  const draftId = params.get("draft_id");
  if (draftId && /^[a-f0-9]{32}$/u.test(draftId)) {
    configuratorUrl.searchParams.set("draft_id", draftId);
  }
  return configuratorUrl.toString();
};
